export const initSubmenuObserver = (): void => {
  const $desktopSubmenu = document.querySelector<HTMLUListElement>(
    '.current-menu-ancestor > .main-desktop-menu__sub-menu-1',
  )
  const $mobileSubmenu = document.querySelector<HTMLElement>('#main-mobile-menu-container')

  if ($desktopSubmenu) {
    $desktopSubmenu.addEventListener('click', () => {
      localStorage.removeItem('shouldSwapCurrencies')
      localStorage.removeItem('userFieldDirection')
    })
  }

  if ($mobileSubmenu) {
    $mobileSubmenu.addEventListener('click', () => {
      localStorage.removeItem('shouldSwapCurrencies')
      localStorage.removeItem('userFieldDirection')
    })
  }

  const observer = new IntersectionObserver((entries) => {
    if ($desktopSubmenu) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          $desktopSubmenu.classList?.remove('is-sticky')
          $mobileSubmenu.classList?.remove('is-sticky')
        } else {
          $desktopSubmenu.classList.add('is-sticky')
          $mobileSubmenu.classList.add('is-sticky')
        }
      })
    }
  })
  const $navbar = document.querySelector<HTMLDivElement>('.header__container')

  $navbar && observer.observe($navbar)
}
